import { render, staticRenderFns } from "./UploadFileInput.vue?vue&type=template&id=45efeb78&"
import script from "./UploadFileInput.vue?vue&type=script&lang=ts&"
export * from "./UploadFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFileInput.vue?vue&type=style&index=0&id=45efeb78&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports